import type { FecJournalMappingWithImport } from '../types/fecJournalMappingWithImport'
import { getFecJournalIdentityKey } from './dedupeFecJournalMappings'

export const getSiblingFecJournalMappings = (
  mappings: FecJournalMappingWithImport[],
  mappingId: string,
  siblingIds?: string[],
): FecJournalMappingWithImport[] => {
  const siblingIdSet = new Set(siblingIds ?? [])
  const currentMapping = mappings.find((mapping) => mapping.id === mappingId)
  const identityKey = currentMapping && getFecJournalIdentityKey(currentMapping)
  const seenIds = new Set<string>()
  const siblings: FecJournalMappingWithImport[] = []

  for (const mapping of mappings) {
    if (mapping.id === mappingId || seenIds.has(mapping.id)) {
      continue
    }

    const mappingSiblingIds = mapping.siblingIds ?? []
    const isLinkedBySiblingId = siblingIdSet.has(mapping.id) || mappingSiblingIds.includes(mappingId)
    const isLinkedByIdentity = Boolean(identityKey) && getFecJournalIdentityKey(mapping) === identityKey

    if (!isLinkedBySiblingId && !isLinkedByIdentity) {
      continue
    }

    seenIds.add(mapping.id)
    siblings.push(mapping)
  }

  return siblings
}
